<template>
  <h1>Welcome to admin indexer panel!!</h1>
</template>

<script>
  export default {
    name: "homepage"
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Homepage.vue